module.exports = __webpack_public_path__ + "static/media/labore_brand_banner.3491a374.jpg";